export const ACTIONS_NOTIFICATIONS = {
  get_user_notifications: "GET_USER_NOTIFICATIONS",
  mark_notification_read: "MARK_NOTIFICATION_READ",
  delete_notification: "DELETE_NOTIFICATION",
  get_unread_notification_count: "GET_UNREAD_NOTIFICATION_COUNT",
  mark_all_notifications_read: "MARK_ALL_NOTIFICATIONS_READ",
};
